export const navigationRoutes = {
  root: {
    name: "/",
    displayName: "navigationRoutes.home",
  },
  routes: [
    // {
    //   name: 'dashboard',
    //   displayName: 'menu.dashboard',
    //   meta: {
    //     iconClass: 'vuestic-iconset vuestic-iconset-dashboard'
    //   }
    // },
    {
      name: "orders",
      displayName: "Заказы",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-components",
      },
    },
    // {
    //   name: "delivery",
    //   displayName: "Доставка",
    //   meta: {
    //     iconClass: "vuestic-iconset vuestic-iconset-time",
    //   },
    // },
    {
      name: "rejected-orders",
      displayName: "Отменные заказы",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-components",
      },
    },
    {
      name: "products",
      displayName: "Товары",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-files",
      },
      children: [
        {
          name: "products",
          displayName: "Все товары",
        },
        {
          name: "categories",
          displayName: "Категории",
        },
      ],
    },
    {
      name: "locations",
      displayName: "Наши магазины",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-maps",
      },
    },
    {
      name: "promocodes",
      displayName: "Промокоды",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-ui-elements",
      },
    },
    // {
    //   name: "additional-products",
    //   displayName: "Доп. услуги",
    //   meta: {
    //     iconClass: "vuestic-iconset vuestic-iconset-extras",
    //   },
    // },
    {
      name: "reviews",
      displayName: "Отзывы",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-comments",
      },
    },
    {
      name: "delivery-management",
      displayName: "Доставка",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-dashboard",
      },
      children: [
        { name: "delivery-types", displayName: "Типы доставки" },
        { name: "delivery-slots", displayName: "Временные слоты" },
        { name: "delivery-calendar", displayName: "Календарь доставки" },
        { name: "delivery-slot-exceptions", displayName: "Исключения слотов" },
        { name: "delivery-promotions", displayName: "Акции доставки" },
      ],
    },
    {
      name: "callbacks",
      displayName: "Обратные звонки",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-forms",
      },
    },
    {
      name: "products-reviews",
      displayName: "Отзывы к продукту",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-comments",
      },
    },
    {
      name: "florists",
      displayName: "Флористы",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-user",
      },
    },
    {
      name: "florist-reviews",
      displayName: "Отзывы флористов",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-comments",
      },
    },
    // {
    //   name: "florist-requests",
    //   displayName: "Заявки флористов",
    //   meta: {
    //     iconClass: "vuestic-iconset vuestic-iconset-forms",
    //   },
    // },
    {
      name: "content",
      displayName: "Контент страниц",
      meta: {
        iconClass: "vuestic-iconset vuestic-iconset-dashboard",
      },
      children: [
        {
          name: "banners",
          path: "promo-banners",
          displayName: "Промо-Баннеры",
        },
        {
          name: "main-page",
          path: "main-page",
          displayName: "Плитка категорий",
        },
        {
          name: "schema",
          path: "schema",
          displayName: "Schema",
        },
        {
          name: "catalog-menu",
          path: "catalog-menu",
          displayName: "Меню каталога",
        },
        {
          name: "showcase",
          path: "showcase",
          displayName: "Онлайн-витрина",
        },
      ],
    },
  ],
};
